












































import { Component, Mixins } from "vue-property-decorator";
import { MultiOrderableDocumentKindListSelector } from "../selectors";
import { MultiOrderableDocumentKindListSelectorDialogMixin } from "./mixins";

@Component({
  components: {
    MultiOrderableDocumentKindListSelector,
  }
})
export default class MultiOrderableDocumentKindListSelectorDialog extends Mixins(MultiOrderableDocumentKindListSelectorDialogMixin) {
}
